import moment from 'moment';
import React, { FunctionComponent } from 'react';
import { meetingSimpleSelectors } from '../../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { convertAndFormatDateToUserTimeZone, difference } from '../../../../../../../utils/date.utils';
import { useSelect, useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { IMeetingNameProps } from './types';
import { authSelectors } from '../../../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../../../app/resource/user/user.selectors';

export const MeetingName: FunctionComponent<IMeetingNameProps> = ({ meetingId }) => {
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);
  const userId = useSelect(authSelectors.selectLoggedUser) || '';
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);

  const nextSessionUTC = meeting?.nextSession;
  const nextSessionTZFormatted =
    user && meeting && convertAndFormatDateToUserTimeZone(meeting?.nextSession, user?.timezone);

  return (
    <span title={nextSessionTZFormatted ?? undefined}>
      {meeting ? meeting.title + ', in ' : ' No next meetings'}
      {meeting ? difference(moment().utc(), nextSessionUTC) : ''}
    </span>
  );
};
